<template>
    <div>
        <el-form :model="attributeForm" ref="ruleForm" label-width="70px" class="demo-ruleForm">
            <el-form-item
                v-for="(item, index) of attributeForm.attributeList"
                :key="index"
                :rules="
                    item.isRequired == 1 && item.disabled == 1
                        ? {
                              required: true,
                              message: item.nameKv.kvName + '不能为空',
                              trigger: 'blur'
                          }
                        : { required: false }
                "
                :prop="item.valueType == 1 ? 'attributeList.' + index + '.kvName' : 'attributeList.' + index + '.valueKvList'"
                :label="item.nameKv.kvName"
            >
                <el-input size="small" v-model="item.valueKvList" v-if="item.valueType == 2"></el-input>

                <el-select v-if="item.valueType == 1" :disabled="item.disabled == 0" v-model="item.kvName" size="small" @change="change">
                    <el-option
                        v-for="(valueKv, index) of item.valueKvList"
                        :key="index"
                        :label="valueKv.kvName"
                        :value="valueKv.kvName"
                    ></el-option>
                </el-select>
                <el-button
                    style="margin-left: 10px"
                    v-if="item.valueType == 1"
                    size="small"
                    type="primary"
                    :disabled="item.disabled == 0"
                    @click="addSpecifications(item)"
                    >添加到规格</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import { get, post, deleteFun } from '@/utils/request.js';

export default {
    data() {
        return {
            attributeForm: {
                nameKv: '',
                spuList: [],
                attributeList: []
            },

            rules: {}
        };
    },
    created() {
        eventBus.$on('attribute', (data) => {
            console.log(data); //componentA参数
            this.getAttributeKvList(data);
        });
        eventBus.$on('speckvName', (data) => {
            console.log(data); //componentA参数
            console.log(this.attributeForm.attributeList);
            for (let item of this.attributeForm.attributeList) {
                if (item.nameKv.kvName == data) {
                    item.disabled = 1;
                    this.$forceUpdate();
                }
            }
        });
    },
    beforeDestroy() {
        eventBus.$off('attribute');
        eventBus.$off('speckvName');
    },
    methods: {
        change(e) {
            console.log(e);
            console.log(this.attributeForm.attributeList);
        },
        getAttributeKvList(data) {
            get(`/washcloud/attribute/getAttributeKvList`, { ...data }).then((res) => {
                if (res.success && res.code == 200) {
                    this.attributeForm.attributeList = res.list;
                    // let i = 1;
                    for (let item of this.attributeForm.attributeList) {
                        item.disabled = 1;
                        // if (item.valueType != 2) {
                        //     item.checkName = null;
                        // }
                        // this.$forceUpdate();
                    }
                    console.log(this.attributeForm.attributeList);
                    // console.log(this.attributeForm.spuList);
                }
            });
        },
        validateForm() {
            let flag = true;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    flag = true;
                } else {
                    console.log('error submit!!');
                    flag = false;
                }
            });
            return flag;
        },

        // atriChange() {
        //     console.log(this.attributeForm);
        //     eventBus.$emit('attributeForm', this.attributeForm);
        // },
        addSpecifications(item) {
            console.log(item);
            item.disabled = 0;
            this.$forceUpdate();
            for (let element of item.valueKvList) {
                element.name = item.nameKv.kvName;
            }

            let obj = {
                nameKvId: item.nameKvId,
                kvName: item.nameKv.kvName,
                valueKv: item.valueKvList
            };
            console.log('1111111111111111111',obj);
            eventBus.$emit('Specification', obj);
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-input {
    width: 200px;
}
::v-deep .el-select {
    width: 200px;
}
</style>
